import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import MyReports from './pages/MyReports';
import Billing from './pages/Billing';
import AuthCallback from './pages/AuthCallback';
import CheckoutOptions from './pages/CheckoutOptions';
import Admin from './pages/Admin';
import CookieBanner from './components/CookieBanner';

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <div className="min-h-screen flex flex-col">
                    <Navbar />
                    <main className="flex-1">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/pricing" element={<Pricing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/auth/callback" element={<AuthCallback />} />
                            <Route path="/dashboard" element={
                                <PrivateRoute><Dashboard /></PrivateRoute>
                            } />
                            <Route path="/reports" element={
                                <PrivateRoute><MyReports /></PrivateRoute>
                            } />
                            <Route path="/billing" element={
                                <PrivateRoute><Billing /></PrivateRoute>
                            } />
                            <Route path="/checkout-options" element={
                                <PrivateRoute><CheckoutOptions /></PrivateRoute>
                            } />
                            <Route path="/admin" element={
                                <PrivateRoute><Admin /></PrivateRoute>
                            } />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </main>
                    <Footer />
                    <CookieBanner />
                </div>
            </BrowserRouter>
        </AuthProvider>
    );
}
